const bwGallery = document.querySelector('.bw-product .pd-gallery');
const bwFrames = [...document.querySelectorAll('.bw-product .pd-image')];
const bwGalleryButtons = [...document.querySelectorAll('.bw-product [data-image]')];
function bwShowImage(index) {
  bwFrames.forEach((frame, i) => { frame.hidden = i !== index; });
  bwGalleryButtons.forEach((button, i) => {
    button.classList.toggle('is-current', i === index);
    button.setAttribute('aria-pressed', String(i === index));
  });
}
bwGalleryButtons.forEach((button, index) => button.addEventListener('click', () => bwShowImage(index)));
let bwTouchStartX = 0;
bwGallery?.addEventListener('touchstart', event => { bwTouchStartX = event.changedTouches[0].screenX; }, { passive: true });
bwGallery?.addEventListener('touchend', event => {
  const distance = event.changedTouches[0].screenX - bwTouchStartX;
  if (Math.abs(distance) < 45) return;
  const current = bwGalleryButtons.findIndex(button => button.classList.contains('is-current'));
  bwShowImage((current + (distance < 0 ? 1 : -1) + bwFrames.length) % bwFrames.length);
}, { passive: true });

document.querySelectorAll('.bw-product .pd-pack-options button').forEach(button => button.addEventListener('click', () => {
  if (button.disabled) return;
  const root = button.closest('.bw-product');
  const variantInput = root.querySelector('#bw-variant-id');
  variantInput.value = button.dataset.variantId;
  variantInput.disabled = false;
  root.querySelector('#pack-price').innerHTML = '';
  root.querySelector('#pack-price').append(document.createTextNode(button.dataset.price + ' '));
  const currency = document.createElement('small');
  currency.textContent = root.dataset.currency;
  root.querySelector('#pack-price').append(currency);
  const buyButton = root.querySelector('#buy-link');
  buyButton.disabled = false;
  root.querySelector('#bw-buy-label').textContent = 'Add to cart';
  root.querySelectorAll('.pd-pack-options button').forEach(other => {
    const selected = other === button;
    other.classList.toggle('is-selected', selected);
    other.setAttribute('aria-pressed', String(selected));
  });
}));

// Carry the Wine Collection's five-photo fade into the product closing story.
(() => {
  const photoFrame = document.querySelector('.bw-product .pd-place-image');
  const photos = [...(photoFrame?.querySelectorAll('img') || [])];
  if (!photoFrame || photos.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let current = 0;
  let running = false;
  let timer;
  photos[0].style.zIndex = '1';

  const showNext = async () => {
    if (!running) return;
    const next = (current + 1) % photos.length;
    try { await photos[next].decode(); } catch (_) { /* The image can still be displayed. */ }
    if (!running) return;
    photos[next].style.zIndex = '2';
    photos[next].classList.add('is-visible');
    timer = setTimeout(() => {
      photos[current].classList.remove('is-visible');
      photos[current].style.zIndex = '0';
      photos[next].style.zIndex = '1';
      current = next;
      if (running) timer = setTimeout(showNext, 3000);
    }, 1600);
  };

  const setRunning = visible => {
    clearTimeout(timer);
    running = visible && !document.hidden;
    if (running) timer = setTimeout(showNext, 3000);
  };

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      photoFrame.dataset.visible = String(entries[0].isIntersecting);
      setRunning(entries[0].isIntersecting);
    }, { threshold: 0.2 });
    observer.observe(photoFrame);
    document.addEventListener('visibilitychange', () => setRunning(photoFrame.dataset.visible === 'true'));
  } else setRunning(true);
})();
